import { Icon, IconProps } from '@chakra-ui/react';

export const OutlookIcon: React.FC<IconProps> = (props) => (
  <Icon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect width="9.61515" height="9.61529" fill="#1A202C" />
    <rect x="10.3838" width="9.61515" height="9.61529" fill="#1A202C" />
    <rect y="10.3848" width="9.61515" height="9.61529" fill="#1A202C" />
    <rect
      x="10.3838"
      y="10.3848"
      width="9.61515"
      height="9.61529"
      fill="#1A202C"
    />
  </Icon>
);
